// 参考借鉴
// http://www.w3school.com.cn/xmldom/dom_http.asp
// https://github.com/Tencent/weui.js/blob/master/src/uploader/upload.js
import Utils from '@packages/utils/utils.js';
import EventBus from '@packages/utils/eventBus.js';
import ImageHelper from '@packages/utils/image.js';
import Extends from '@packages/utils/extends.js';
var Uploader = function (el, options) {
  this.wrapper = (typeof el === 'string' ? document.querySelector(el) : el);
  var defaults = {
    url: null,
    type: 'POST',
    async: true,
    data: {},
    headers: {},
    xhrFields: {},
    compress: {
      type: 'image/png',
      quality: '0.92',
      width: null,
      height: null
    },
    base64: null,
    autoUpload: true,
    fileType: [],
    onInit: Utils.noop,
    onBefore: Utils.noop,
    onSuccess: Utils.noop,
    onError: Utils.noop,
    onComplete: Utils.noop,
    onProgress: Utils.noop
  }
  this.options = defaults;
  Extends(this.options, options);
  this.unique = this.options.unique || Utils.getUnique();
  this._init();
}
Uploader.prototype = {
  _init: function () {
    var self = this;
    self.observer = EventBus.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
    self.options.base64 && self._sendBase64();
  },
  _addEvent: function () {
    var self = this;
    if (!self.options.base64) {
      var $wrapper = self.wrapper;
      $wrapper.querySelector('input[type="file"]').addEventListener('change', function (event) {
        self._onChange(event);
      }, false);
    }
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  _onChange: function (event) {
    var self = this;
    var _files = event.target.files;
    if (_files.length === 0) {
      return;
    }
    self.files = _files;
    if (!self._isLegalType(self.files[0])) {
      return false;
    }
    self._handleImage(self.files[0], function (file) {
      self.file = file;
      self.observer.emit('onBefore', file);
      self.options.autoUpload && self._sendXHR(file);
    });
  },
  _sendXHR: function (file) {
    var self = this;
    var _xhr = new XMLHttpRequest();
    self._xhr = _xhr;
    var _options = self.options;
    self._setFormDate(file);
    self._setXhrFields();
    _xhr.onreadystatechange = function () {
      self._onReadyStateChange();
    };
    _xhr.upload.onprogress = function (event) {
      self._onProgress(event);
    };
    _xhr.open(_options.type, _options.url, _options.async);
    self._setHeaders();
    _xhr.send(self._formData);
  },
  _sendBase64: function () {
    var self = this;
    var blob = ImageHelper.dataURItoBlob(self.options.base64);
    self.file = blob;
    self.observer.emit('onBefore', blob);
    self.options.autoUpload && self._sendXHR(blob);
  },
  _onReadyStateChange: function () {
    var self = this;
    var _xhr = self._xhr;
    var response = '';
    // readyState, http://www.w3school.com.cn/xmldom/dom_http.asp
    // 0,Uninitialized,初始化状态。XMLHttpRequest 对象已创建或已被 abort() 方法重置。
    // 1,Open,open() 方法已调用，但是 send() 方法未调用。请求还没有被发送。
    // 2,Sent,Send() 方法已调用，HTTP 请求已发送到 Web 服务器。未接收到响应。
    // 3,Receiving,所有响应头部都已经接收到。响应体开始接收但未完成。
    // 4,Loaded,HTTP 响应已经完全接收。
    if (_xhr.readyState === 4) {
      if (_xhr.status === 200) {
        try {
          _xhr.responseText && (response = JSON.parse(_xhr.responseText));
          self.observer.emit('onSuccess', response);
        } catch (error) {
          self.observer.emit('onError', _xhr, _xhr.status, error);
        }
      } else {
        self.observer.emit('onError', _xhr, _xhr.status, _xhr.statusText);
      }
      self.observer.emit('onComplete', _xhr);
      _xhr.abort();
    }
  },
  _onProgress: function (event) {
    var self = this;
    if (event.total === 0) return;
    var percent = Math.ceil(event.loaded / event.total) * 100;
    self.observer.emit('onProgress', percent);
  },
  _setFormDate: function (file) {
    var self = this;
    var _formData = new FormData();
    var _data = self.options.data;
    for (var key in _data) {
      _formData.append(key, _data[key]);
    }
    _formData.append('file', file);
    self._formData = _formData;
  },
  _setHeaders: function () {
    var self = this;
    var _xhr = self._xhr;
    var _headers = self.options.headers;
    for (var key in _headers) {
      _xhr.setRequestHeader(key, _headers[key]);
    }
  },
  _setXhrFields: function () {
    var self = this;
    var _xhr = self._xhr;
    var _xhrFields = self.options.xhrFields;
    for (var key in _xhrFields) {
      _xhr[key] = _xhrFields[key];
    }
  },
  _handleImage: function (file, callback) {
    var self = this;
    var reader = new FileReader();
    reader.onload = function (event) {
      self._imageToBlob(file, event, callback);
    }
    reader.readAsDataURL(file);
  },
  _imageToBlob: function (file, event, callback) {
    var self = this;
    var img = new Image();
    img.src = event.target.result;
    img.onload = function () {
      // var ratio = ImageHelper.detectVerticalSquash(img);
      var orientation = ImageHelper.getOrientation(ImageHelper.dataURItoBuffer(img.src));
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var width = img.width;
      var height = img.height;
      var maxW = self.options.compress.width;
      var maxH = self.options.compress.height;
      if (maxH && width < height && height > maxH) {
        width = parseInt(maxH * img.width / img.height);
        height = maxH;
      } else if (maxW && width >= height && width > maxW) {
        height = parseInt(maxW * img.height / img.width);
        width = maxW;
      }
      canvas.width = width;
      canvas.height = height;
      if (orientation > 0) {
        ImageHelper.orientationHelper(canvas, ctx, orientation);
      }
      ctx.drawImage(img, 0, 0, width, height);
      var dataURL = canvas.toDataURL(self.options.compress.type, self.options.compress.quality);
      if (/;base64,null/.test(dataURL) || /;base64,$/.test(dataURL)) {
        callback(file);
      } else {
        var blob = ImageHelper.dataURItoBlob(dataURL);
        blob.name = file.name;
        blob.lastModified = file.lastModified;
        blob.lastModifiedDate = file.lastModifiedDate;
        callback(blob);
      }
    }
  },
  _isLegalType: function (file) {
    var self = this;
    var _fileType = self.options.fileType;
    _fileType || (_fileType = []);
    if (_fileType.length <= 0) {
      _fileType.push('jpg');
      _fileType.push('jpeg');
      _fileType.push('png');
      _fileType.push('gif');
      _fileType.push('bmp');
      _fileType.push('svg');
    }
    for (var i = 0; i < _fileType.length; i++) {
      if (file.type.toLowerCase().indexOf(_fileType[i]) !== -1) {
        return true;
      }
    }
    self.observer.emit('onError', null, 404, '请上传指定格式文件');
    return false;
  },
  upload: function () {
    var self = this;
    self._sendXHR(self.file);
  }
}
export default Uploader;



// WEBPACK FOOTER //
// ./packages/components/uploader/uploader.js